import styled from 'styled-components';

import { getThemeColor, getThemePath } from '@utils/styled';

import Typography from '@common/components/Typography';

export const Container = styled.section`
  ${({ theme, isUpcoming }) =>
    isUpcoming && theme.getFluidSpacing('margin-bottom', 'section', 4)}
  border: 1px solid ${getThemeColor('bluegrey.90')};
  border-radius: ${getThemePath(['borderRadiuses', 'normal.2'])}rem;
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 2)}
  padding-right: 1.7rem;
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'scale', 2)}
  padding-left: 1.7rem;
  background-color: ${getThemeColor('bluegrey.95')};
`;

export const Title = styled.p`
  margin: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 5)}
  ${({ theme }) => theme.getFluidFont('body7')}
  font-weight: 700;
  text-align: center;
`;

export const Register = styled.div`
  max-width: 769px;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 2)}
  margin-right: auto;
  margin-left: auto;
  border-top: 1px solid ${getThemeColor('bluegrey.70')};
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 2)}
  padding: 0 0.5rem;
  text-align: center;
`;

export const RegisterTitle = styled(Typography).attrs({
  variant: 'h6',
})`
  margin-bottom: 1.1rem;
`;

export const RegisterDescription = styled(Typography).attrs({
  variant: 'body1',
})`
  margin-bottom: 1.6rem;
`;
